import { subDays } from "date-fns";
import { INormalizedChartDate } from "../types";
import { createEmptyEntry } from "./createEmptyEntry";



export const addDaysBeforeDate = (count: number, startDate: Date): INormalizedChartDate[] => {
  if (count <= 0) return [];
  
  const result: INormalizedChartDate[] = [];
  for (let i = count; i > 0; i--) {
    result.push(createEmptyEntry(subDays(startDate, i)));
  }
  return result;
};